
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取已配置的部门
export function getDeptHasBeenConfigured (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevantEquis',
    method: 'GET',
    params: parameter
  })
}
// 更新已配置的部门
export function upDataDeptHasBeenConfigured (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevantEqui',
    method: 'POST',
    data: parameter
  })
}
// 获取未配置的部门
export function getDeptUnConfigured (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/relevantEquisByNotConfig',
    method: 'GET',
    params: parameter
  })
}
// 获取设备归口权限列表
export function getDeptEquiPermission (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/deptEqui/permission',
    method: 'GET',
    params: parameter
  })
}
// 新增设备归口角色权限
export function upDataDeptEquiPermission (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/role/deptEqui/permission',
    method: 'POST',
    data: parameter
  })
}